import {
    faCogs,
    faHome,
    faMapMarked,
    faSitemap,
    faTachometer,
    faUsersCog,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MainLayout } from "components/generic";
import GisPage from "pages/gispage";
import UsersPage from "pages/userspage";
import WelcomePage from "pages/welcomepage";
import React from "react";
import { useIntl } from "react-intl";
import { connect } from "react-redux";
import { Page } from "types/generic";
import {
    getEnvVariable,
    REACT_APP_COCKPIT_URL,
    REACT_APP_PORTAL_ADMIN_ROLE,
    REACT_APP_PORTAL_HIERARCHY_ROLE,
    REACT_APP_PORTAL_GIS_ROLE,
} from "utils/environment";

const AdministrationPage = (props: { userRoles: string[] }) => {
    const intl = useIntl();

    let availablePages: Page[] = [
        {
            id: "home",
            title: "Home",
            icon: () => <FontAwesomeIcon icon={faHome} />,
            content: () => <WelcomePage />,
        },
    ];
    if (props.userRoles.includes(getEnvVariable(REACT_APP_PORTAL_ADMIN_ROLE))) {
        availablePages.push({
            id: "users",
            title: "Users Admin",
            icon: () => <FontAwesomeIcon icon={faUsersCog} />,
            content: () => <UsersPage />,
        });
    }
    if (props.userRoles.includes(getEnvVariable(REACT_APP_PORTAL_GIS_ROLE))) {
        availablePages.push({
            id: "gis",
            title: "GIS Layers Admin",
            icon: () => <FontAwesomeIcon icon={faMapMarked} />,
            content: () => <GisPage />,
        });
    }
    if (getEnvVariable(REACT_APP_COCKPIT_URL)) {
        availablePages.push({
            id: "cockpit",
            title: "Cockpit",
            icon: () => <FontAwesomeIcon icon={faTachometer} />,
        });
    }

    const availableApplications = [
        {
            id: "administration",
            title: `${intl.formatMessage({
                id: "app.general.administration_platform",
            })}`,
            icon: () => <FontAwesomeIcon icon={faCogs} />,
            url: "/administration/",
            pages: availablePages,
        },
        // {
        //   id: "administration",
        //   title: "portal",
        //   icon: () => <FontAwesomeIcon icon={faCogs} />,
        //   url: "/portal",
        //   pages: availablePages,
        // },
    ];

    return (
        <MainLayout
            pages={availablePages}
            applications={availableApplications}
        />
    );
};

const mapStateToProps = (state: any) => {
    return {
        userRoles: state.keycloak.userRoles,
    };
};

export default connect(mapStateToProps, null)(AdministrationPage);
